import React, { useRef } from "react";
import Slider from "react-slick/lib/slider";
import img1 from "../../../images/Testimonial/img1.jpg";
import img2 from "../../../images/Testimonial/img2.jpg";
import img3 from "../../../images/Testimonial/img3.jpg";
import img4 from "../../../images/Testimonial/img4.jpg";
import "./Testimonial.css";
import TestimonialItem from "./TestimonialItem";

const Testimonial = () => {
  const sliderRef = useRef(null);
  const settings = {
    className: "center",
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    centerPadding: "60px",
    slidesToShow: 3,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div className="my-3 any testimonial_bg_weShare">
      <div className="container">
        <div className="testimonal">
          <div className="row w-100 mx-auto">
            <div className="testimonial_title mb-5 mt-3">
              <h1>
                <span>What</span>{" "}
                <span className="text-blue"> our Clients say</span>
              </h1>
            </div>
            <Slider {...settings} ref={sliderRef}>
              <TestimonialItem
                name="Jane,"
                location="New York"
                comment="Excellent communication, absolutely lovely people, amazing House!!! and an incredibly smooth process!"
                img={img1}
              />
              <TestimonialItem
                name="Rafi,"
                location="Berlin"
                comment="This is my second rental with Mike - great equipment, great price and brilliant service!"
                img={img2}
              />
              <TestimonialItem
                settings={settings}
                name="Lui,"
                location="Tokyo"
                comment="Paul is a very nice guy and very easy to deal with. Great car, good price and really easy to collect and return."
                img={img3}
              />
              <TestimonialItem
                name="Ainat,"
                location="Tel Aviv"
                comment="Betty was a super nice, her gear was perfect for my project. Highly recommend."
                img={img4}
              />
            </Slider>
            <div className="d-flex testimonial_main align-items-center justify-content-between">
              <div
                className="testimonial_left"
                onClick={() => sliderRef.current.slickPrev()}
              >
                <i className="fas fa-arrow-left"></i>
              </div>
              <div
                className="testimonial_right"
                onClick={() => sliderRef.current.slickNext()}
              >
                <i className="fas fa-arrow-right"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonial;
